module.exports = __webpack_public_path__ + "img/CM-SS-CA-Acura-Lifestyle.19343db2.jpeg";